































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Legal } from "@/typings/store/plugins/easyFirestore/legales";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoLegal extends Vue {
  @Prop() readonly legal!: Legal;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.legal.id || "N/R";
  }

  get nombre(): string {
    return this.legal.nombre || "N/R";
  }

  get posicion(): string {
    return this.legal.posicion || "N/R";
  }


  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
